/* @flow strict */

import * as React from 'react';
import { GET_WITH_REDIRECT } from '/client/src/api/';
import Credentials from '/client/src/api/Credentials';
import { withRouter } from 'react-router-dom';
import EventDetailContainer from '/client/src/container/eventDetails';
import EventPageDetailManage from './manage.jsx';
import EventPageDetailCustomers from './customers/';
import EventPageDetailStats from './stats';
import SchEmailsPage from './scheduleEmails';
import EventPageDetailResend from './resend';
import EventPageDesign from './design';
import NotFound from '../../NotFound';
import SelfCheckIn from './selfCheckinRoot/selfChekin';
import SchRefaundPage from './refund';
import RefLinksPage from './refLinks';
import CollaboratorPage from './collaborators';
import CreateEditEvent from './createEdit';
import AddGuestPage from './import';
import CodesPage from './codes';
import EventPageDetailDicountCodes from './dicountCodes';
import EventPageDetailVIPCodes from './VIPCodes';
import EventMailchimpSettings from './mailchimp';
import EventBadgePrinting from './badgePrinting';
import EventPageDetailSponsorBody from './sponsor';
import PhysicalTicktetPage from './physicalTicket';
import StripeConnectWarningDialog from '/client/src/components/dialogs/stripeNotIssetWarning';
import { CheckStripeConnection } from '/client/src/pages/Events/detail/physicalTicket/helper';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  match: {
    params: {
      viewTab: string,
      subViewTab?: string,
      tableTab?: string,
      eventId: number | string
    }
  },
  history: {
    goBack: () => void
  }
};

// TODO: Add uses this array to dynamic render
// eslint-disable-next-line
const manageTopNavBar = [
  'stats',
  'manage',
  'guest',
  'edit',
  'design'
];

// TODO: Add uses this array to dynamic render
// eslint-disable-next-line
const manageTilesItem = [
  'reminders',
  'resend',
  'refund',
  'ref-links',
  'collaborators',
  undefined
];

const queryString = require('query-string');

const EventPageDetail = ({ match, history }: PropsType): React.Element<typeof React.Fragment> => {
  const context = React.useContext(DefaultContainerContext);
  const { params: { viewTab, subViewTab, eventId } } = match;
  const [isShowStripeWarning, handleShowStripeWarning] = React.useState(false);
  const confirmStripeWarn = async (status: boolean) => {
    handleShowStripeWarning(false);

    if (!status) {
      history.goBack();
    } else {
      const token = Credentials.getToken();

      window.localStorage.setItem('SPARXO_lastPage', window.location.pathname);

      await GET_WITH_REDIRECT(`/api/v1/1/merchants/payment/stripe/auth?access_token=${token}`, {
        chnageRedirect: `${window.location.origin}/payment/stripe/oauth2/callback`
      });
    }
  };

  return (
    <EventDetailContainer>
      {viewTab === 'manage' ?
        <>
          {((): React.Element => {
            switch (subViewTab) {
              case 'reminders':
                return (
                  <SchEmailsPage
                    eventId={eventId}
                    subViewTab={subViewTab}
                  />
                );

              case 'resend':
                return (
                  <EventPageDetailResend />
                );

              case 'self-checkin':
                return (
                  <SelfCheckIn eventId={eventId} />
                );

              case 'refund':
                return (
                  <SchRefaundPage
                    eventId={eventId}
                  />
                );

              case 'ref-links':
                return (
                  <RefLinksPage
                    eventId={eventId}
                  />
                );

              case 'collaborators':
                return (
                  <CollaboratorPage
                    eventId={eventId}
                    defaultContainerContext={context}
                  />
                );

              case 'import':
                return (
                  <AddGuestPage
                    eventId={eventId}
                  />
                );

              case 'codes':
                return (
                  <CodesPage
                    eventId={eventId}
                  />
                );

              case 'discount-codes':
                return (
                  <EventPageDetailDicountCodes
                    eventId={eventId}
                    subViewTab={subViewTab}
                  />
                );

              case 'vip-codes':
                return (
                  <EventPageDetailVIPCodes
                    eventId={eventId}
                    subViewTab={subViewTab}
                  />
                );
              case 'mailchimp':
                return (
                  <EventMailchimpSettings
                    eventId={eventId}
                  />
                );
              case 'badge-printing':
                return (
                  <EventBadgePrinting
                    eventId={eventId}
                  />
                );

              case 'physical-ticket':
                return (
                  <CheckStripeConnection handleShowStripeWarning={handleShowStripeWarning}>
                    {isShowStripeWarning ?
                      <PhysicalTicktetPage eventId={eventId} /> :
                      <StripeConnectWarningDialog
                        handleShow={handleShowStripeWarning}
                        callback={confirmStripeWarn}
                      />
                    }
                  </CheckStripeConnection>
                );

              case 'sponsor':
                return (
                  <EventPageDetailSponsorBody eventId={eventId} />
                );

              case undefined:
                return (
                  <EventPageDetailManage eventId={eventId} />
                );

              default:
                return (
                  <NotFound />
                );
            }
          })()}
        </> :
        null
      }

      {viewTab === 'customers' ?
        <EventPageDetailCustomers eventId={eventId} subViewTab={subViewTab} /> : null
      }

      {viewTab === 'stats' ?
        <EventPageDetailStats eventId={eventId} /> : null
      }

      {viewTab === 'design' ?
        <EventPageDesign eventId={eventId} />
        : null
      }

      {viewTab === 'edit' || viewTab === 'clone' ?
        <CreateEditEvent eventId={eventId} /> : null
      }

      {!viewTab && <NotFound />}
    </EventDetailContainer>
  );
};

export default withRouter(EventPageDetail);
